import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import ApiService from '../../../services/apiService';
export default {
  name: 'NiotaClassicConsumersForm',
  mixins: [formMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;

    return {
      titleRules: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }],
      consumerCanBeEdited: true,
      plainAccounts: [],
      consumerTypes: ['MQTT', 'Websocket', 'Webhook', 'Azure'],
      isIEC104IntegrationActive: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    statusItems: function statusItems() {
      var _this2 = this;

      return ['public', 'private'].map(function (s) {
        return {
          text: _this2.$i18n_t("NiotaClassic.DataSources.form.status_".concat(s)),
          value: s
        };
      });
    }
  }),
  watch: {},
  created: function created() {
    this.formItem = cloneDeep(this.editedItem);
    this.getPlainAccounts(); // In create case:

    if (!this.formItem.accountId) {
      this.formItem.accountId = this.$store.state.authentication.tenantId;
    }

    this.checkAccountIEC104Integration(this.formItem.accountId);
  },
  methods: {
    createRequest: function createRequest() {
      this.formItem.applications = [];
      this.formItem.options = {};

      if (this.formItem.type === 'IEC-60870-5-104') {
        this.formItem.options.dataPoints = [];
        this.formItem.options.clientWhitelist = [];
      }

      return NiotaClassicApiService.consumersCreate(this.formItem);
    },
    getPlainAccounts: function getPlainAccounts() {
      var _this3 = this;

      NiotaClassicApiService.accountsFetchPlain().then(function (res) {
        _this3.plainAccounts = res.data.accounts;
      }).catch(function () {
        _this3.$snack(_this3.$i18n_t('Common.errorFetchingAccounts'), 'error');
      });
    },
    checkAccountIEC104Integration: function checkAccountIEC104Integration(accountId) {
      var _this4 = this;

      ApiService.getVersionDriftAccountIntegrations(accountId).then(function (res) {
        _this4.isIEC104IntegrationActive = res.find(function (integration) {
          return integration.type === 'iec104';
        });

        _this4.updateConsumerTypesArray();
      }).catch(function (err) {
        return console.error(err);
      });
    },
    updateConsumerTypesArray: function updateConsumerTypesArray() {
      var iec104 = 'IEC-60870-5-104';
      var iec104Index = this.consumerTypes.indexOf(iec104);

      if (this.isIEC104IntegrationActive) {
        // if the IEC104 active and it is not listed, add it to the list
        if (iec104Index === -1) {
          this.consumerTypes.push(iec104);
        }
      } else {
        // if the IEC104 not active and it is listed, remove it from the list
        if (iec104Index !== -1) {
          this.consumerTypes.splice(iec104Index);
        }
      }
    }
  }
};